import { motion } from 'framer-motion';

/**
 * RadialReadinessMeter, SVG concentric progress ring for Launch Readiness.
 * Uses stroke-dashoffset math + a cyan→blue gradient and soft glow.
 */
export default function RadialReadinessMeter({ percent = 0, level = 'Explorer', size = 220, label = 'Launch Ready' }) {
  const stroke = size * 0.09;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (Math.max(0, Math.min(100, percent)) / 100) * circ;

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }} data-testid="launch-readiness-meter">
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id="lrm-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#22d3ee" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
          <filter id="lrm-glow">
            <feGaussianBlur stdDeviation="3.5" result="b" />
            <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#1e293b" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke="url(#lrm-grad)" strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circ}
          filter="url(#lrm-glow)"
          initial={{ strokeDashoffset: circ }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <span className="font-mono font-bold text-white leading-none" style={{ fontSize: size * 0.26 }} data-testid="launch-readiness-percent">
          {percent}<span className="text-cyan-300" style={{ fontSize: size * 0.13 }}>%</span>
        </span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-slate-300 mt-1">{label}</span>
        <span className="text-xs font-semibold text-cyan-300 mt-1" data-testid="launch-readiness-level">{level}</span>
      </div>
    </div>
  );
}
